import React, { Component } from "react";
import StepWizard from "react-step-wizard";
//// componentes reutilizables
import Titulo from "../../generico/TituloPagina";
import Paso1 from "./EducacionPaso1";
import Paso2 from "./EducacionPaso2";
import Paso3 from "./EducacionPaso3";
import Paso4 from "./EducacionPaso4";

export default class ActividadEducacion extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
    this.paso1 = React.createRef();
    this.paso2 = React.createRef();
    this.paso3 = React.createRef();
    this.paso4 = React.createRef();
  }
  resetState = () => {
    this.setState(this.getInitialState());
  };
  getInitialState = () => ({
    actividad: {},
    cuentaDebito: {},
    nroOperacion: "",
    cantidadEntradas: undefined
  });
  returnDataPaso1(_actividad) {
    this.setState({
      actividad: _actividad,
    });
  }
  returnDataPaso2(_cuentaDebito, _cantidadEntradas) {
    this.setState({
      cuentaDebito: _cuentaDebito,
      cantidadEntradas: _cantidadEntradas
    });
  }
  returnDataPaso3(_nroOperacion) {
    this.setState({
      nroOperacion: _nroOperacion,
    });
  }
  returnDataPaso4() {
    this.state = this.getInitialState();
    this.initDataChildren();
  }
  initDataChildren() {
    this.paso1.current.initData();
    this.paso2.current.resetState();
    this.paso3.current.resetState();
  }

  onStepChange = (stats) => {
    if (stats.previousStep === 2) {
      this.paso1.current.checkGrilla();
    } else if (stats.previousStep === 1) {
      this.paso2.current.suscripcionActividadesValida();
    }
  };
  componentDidMount() {}

  render() {
    return (
      <div className="content-wrapper">
        <Titulo texto="Actividades" />
        <section className="content">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <StepWizard
                      transitions="none"
                      onStepChange={this.onStepChange}
                    >
                      <Paso1
                        ref={this.paso1}
                        returnDataPaso1={this.returnDataPaso1.bind(this)}
                      />
                      <Paso2
                        ref={this.paso2}
                        actividad={this.state.actividad}
                        returnDataPaso2={this.returnDataPaso2.bind(this)}
                      />
                      <Paso3
                        ref={this.paso3}
                        actividad={this.state.actividad}
                        cuentaDebito={this.state.cuentaDebito}
                        cantidadEntradas={this.state.cantidadEntradas}
                        returnDataPaso3={this.returnDataPaso3.bind(this)}
                      />
                      <Paso4
                        ref={this.paso4}                       
                        actividad={this.state.actividad}
                        cuentaDebito={this.state.cuentaDebito}
                        cantidadEntradas={this.state.cantidadEntradas}
                        nroOperacion={this.state.nroOperacion}
                        returnDataPaso4={this.returnDataPaso4.bind(this)}
                      />
                    </StepWizard>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
